enum TEXT {
  // Status
  ATIVO = 'Ativo',
  INATIVO = 'Inativo'
}

export default TEXT;
